import React from 'react'
import { TextInput } from '@paypalcorp/pp-react'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

const InputBox = React.forwardRef((props, ref) => {
  const worldReady = React.useContext(WorldReadyContext)

  return (
    <React.Fragment>
      <TextInput
        ref={ref}
        name={props.name}
        id={props.id}
        className={props.className}
        labelClassName={props.labelClassName}
        value={props.value}
        label={
          props.id === 'createFolder'
            ? new MessageFormat(worldReady, {
                id: props.label,
              }).format()
            : props.label
        }
        isLabelHidden={props.isLabelHidden}
        placeholder={new MessageFormat(worldReady, {
          id: props.placeholder,
        }).format()}
        onChange={(e) => props.onChangeText(e)}
        onKeyPress={(e) => props.onKeyPressText(e)}
        onBlur={(e) => props.onBlurText(e)}
        maxLength={props.maxLength}
        autoFocus={props.autoFocus}
        style={props.style}
        errorText={props?.errorText || ''}
        error={!!props?.errorText}
        type={props?.type || 'text'}
      />
    </React.Fragment>
  )
})

export default InputBox
